import moment from 'moment'
import Papa from 'papaparse'

const DATE_FORMAT = 'YYYY-MM-DD'

// waitUntilTrue wait time
export const waitUntilTrueWaitTime = 20

/**
 * Returns a Promise that will resolve when the input function evaluates as true.
 *
 * @param {Function} testCallback The function to be evaluated.
 * @returns {Promise} Promise that resolves when testCallback returns true.
 */

const checkForTrue = (waitTime, testCallback, finishedCallback) => {
  if (testCallback()) {
    finishedCallback()
    return
  }
  setTimeout(checkForTrue, waitTime, testCallback, finishedCallback)
}

export const waitUntilTrue = (testCallback, waitTime = waitUntilTrueWaitTime) => {
  return new Promise(resolve => {
    checkForTrue(waitTime, testCallback, resolve)
  })
}

/**
 * Returns a Promise that will resolve when the input wait time elapses.
 *
 * @param {number} wait The time to elapse in milliseconds.
 * @returns {Promise} Promise that resolves when the input wait time elapses.
 */
export const wait = wait => {
  return new Promise(resolve => {
    setTimeout(resolve, wait)
  })
}

export const today = () =>
  moment().format(DATE_FORMAT)

export const todayUtc = () =>
  moment.utc().format(DATE_FORMAT)

export const daysBack = (date, days) =>
  moment(date).subtract(days, 'days').format(DATE_FORMAT)

export const dateSubtract = (strDate1, strDate2) =>
  moment(strDate2).diff(moment(strDate1), 'days')

export const sameDayNextMonth = () => {
  if (moment().add(1, 'M').isValid) {
    return moment().add(1, 'M').format(DATE_FORMAT)
  } else {
    return moment().add(1, 'M').clone().endOf('month').format(DATE_FORMAT)
  }
}

export const afterThirtyDaysFromToday = () => {
  if (moment().add(30, 'd').isValid) {
    return moment().add(30, 'd').format(DATE_FORMAT)
  } else {
    return moment().add(30, 'd').clone().endOf('month').format(DATE_FORMAT)
  }
}

export const getWeekNumber = (date) => moment(date, DATE_FORMAT).week()

export const getYear = (date) => moment(date, DATE_FORMAT).year()

export const getDayName = (date) => moment(date, DATE_FORMAT).format('dddd')

export const getMonth = (date) => moment(date, DATE_FORMAT).format('YYYY-MM')

// return previous day - if previous day is Saturday/Sunday then return Friday
export const getYesterday = () => {
  // #339 : function code is blocked to show previosu day as sunday if today is monday.
  // let date = moment().subtract(1, 'days').format(DATE_FORMAT)
  // const day = getDayName(date)
  // if (day === 'Sunday') {
  //   date = moment().subtract(3, 'days').format(DATE_FORMAT)
  // }
  // if (day === 'Saturday') {
  //   date = moment().subtract(2, 'days').format(DATE_FORMAT)
  // }
  // return date
  return moment().subtract(1, 'days').format(DATE_FORMAT)
}

export const downloadCSV = (fileName, columns = [], data) => {
  const name = fileName || 'export.csv'
  let csv
  if (columns.length === 0) {
    csv = Papa.unparse(data)
  } else {
    csv = Papa.unparse({
      fields: columns,
      data
    })
  }
  if (csv == null) return

  const blob = new Blob([csv])
  // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, name)
  } else {
    const a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob, { type: 'text/plain' })
    a.download = name
    document.body.appendChild(a)
    // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
    a.click()
    document.body.removeChild(a)
  }
}

export const enumerateDaysBetweenDates = (startDate, endDate) => {
  const dates = []
  const currDate = moment(startDate).startOf('day')
  const lastDate = moment(endDate).startOf('day')

  while (currDate.add(1, 'days').diff(lastDate) < 0) {
    const getDate = moment(currDate.clone().toDate()).format(DATE_FORMAT)
    dates.push(getDate)
  }

  return dates
}

export const roundNumber = (num) => {
  return Math.round((num + Number.EPSILON) * 100) / 100
}